import React from 'react';
import { type ReactNode } from 'react';
import { Divider } from '@packages/shared/src/ui/Divider/Divider';

export const ActionBar = ({ children }: { children: ReactNode[] }) => (
  <>
    <Divider />
    <div className="flex flex-row justify-end">
      {children?.map(
        (child, index) =>
          child && (
            <React.Fragment
              // eslint-disable-next-line react/no-array-index-key
              key={index}
            >
              {index !== 0 && (
                <Divider orientation="vertical" flexItem className="my-1" data-testid="divider" />
              )}
              {child}
            </React.Fragment>
          ),
      )}
    </div>
  </>
);
